import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MessageService } from '../global/message.service';

@Injectable()
export class ResidentGuard implements CanActivate {
  constructor(private router: Router, public message: MessageService){ }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const party_type = localStorage.getItem('party_type') ? JSON.parse(atob(localStorage.getItem('party_type'))) : null;
    if (party_type['residential_Status'] && party_type['emailid'] && party_type['mobile_no'] && party_type['state'] && party_type['flat_no'] && party_type['locality'] && party_type['city']) {
      return true
    } 
    console.log('Please fill all mandatory fields');
    this.message.displaySnackbarpersonalInfo('Please fill Personal Information details first!!');
    return false;
  }
}